import { FunnelIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import React, { useRef, useState, useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import AddButton from "../../../../components/AddButton";
import ButtonForModal from "../../../../components/ButtonForModal";
import { useHistory, useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import {
  rowForEditScorecard,
  scorecardAddState,
  scorecardEditState,
  scoreCardShowState,
  searchData,
  selectedRowsStateToDelete,
} from "../atoms/atoms";
import { ScoreCardForm } from "../forms/ScoreCardForm";
import { ScoreCardRowDetails } from "./ScoreCardRowDetails";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import TableFilters from "../tableFilters";
import { toast } from "../../../../components/toastNotification";
import { TicketIcon } from "@heroicons/react/24/solid";
import DownloadButton from "../../../../components/DownloadButton";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import useDeactivateScoreCard from "../hooks/useDeactivateScoreCard";
import { useQueryClient } from "react-query";
import { getScoreCardList } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";
import useScoreCardList from "../hooks/useScoreCardList";
import useGetAllEmployeesForScoreCard from "../hooks/useGetAllEmployeesForScoreCard";
import useScoreCardDownload from "../hooks/useScoreCardDownload";

interface ScoreCardTableProps {}

export const ScoreCardTable: React.FC<ScoreCardTableProps> = ({}) => {
  const queryClient = useQueryClient();
  const tableRef = useRef<any>();
  const downloadRef = useRef<any>();
  const setAddState = useSetRecoilState(scorecardAddState);
  const setEditState = useSetRecoilState(scorecardEditState);
  const [isAdd, setIsAddState] = useState(false);
  const [isEdit, setIsEditState] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [, setReset] = useState(true);
  const [filter, setFilter] = useState(false);

  const [isShow, setShowState] = useRecoilState(scoreCardShowState);
  const setRowToEdit = useSetRecoilState(rowForEditScorecard);
  const [caseNumber, setCaseNumber] = useState("");
  const [filteredScorecard, setFilteredScorecard] = useState([]);
  const [rowViewData, setRowViewData] = useState([]);
  const [, setRowEditData] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [, setIds] = useState([]);
  const [scoreCardLists, setScoreCardLists] = useState({});
  const [searchInputsData, setSearchInputsData] = useRecoilState(searchData);
  const [isOnClose, setOnClose] = useState(false);
  const [stayData, setStayData] = useState<any>([]);
  const [orderBy, setorderBy] = useState("");
  const [isSort, SetIsSort] = useState(false);
  const { data: empData, isLoading: empLoading } =
    useGetAllEmployeesForScoreCard();
  const { mutate: downloadScoreCards, isLoading: scoreCardDownloadLoading } =
    useScoreCardDownload();
  // const scoreCard = useScoreCard();
  const [clearFilter, setClearFilter] = useState(false);
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_scorecard_add;
  const editPermission = PERMISSIONS.permission_scorecard_edit;
  const deletePermission = PERMISSIONS.permission_scorecard_delete;
  let recordIdFromRecent;
  const history = useHistory();
  let location = useLocation();

  const [selectedRowsToDelete, setSelectedRowsToDelete] = useRecoilState(
    selectedRowsStateToDelete
  );
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [scoreCardExportData, setScoreCardExportData] = useState([]);

  const [isScorecardLoading, setIsScorecardLoading] = useState(true);

  let dateTimeToday = new Date(new Date().toISOString()).toISOString();
  const search = location.search;
  const qs = new URLSearchParams(search);
  const qsId = qs.get("caseNumber");
  if (qsId && searchId === "") {
    setSearchId(qsId);
    setFilter(true);
    setIsSearching(true);
    setCaseNumber(qsId);
  }
  const {
    mutate: BulkDeleteVendor,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeactivateScoreCard();
  useEffect(() => {
    setShowState(false);
    setRowViewData([]);
  }, [setRowViewData, setShowState]);

  // Get All Details for Download function
  const exportData = () => {
    downloadScoreCards(searchInputsData, {
      onSuccess: (res) => {
        if (res) {
          setScoreCardExportData(
            res?.data?.map((x) => {
              return {
                "Scorecard Number": x.caseNumber
                  ? String(x.caseNumber)?.padStart(10, "0")
                  : "",
                "Office Name": x.account,
                "Contact Name": x.contact,
                "Contact Email": x.contactEmail,
                Status: x.status,
                Subject: x.subject?.includes("\n")
                  ? x.subject.replaceAll("\n", "")
                  : x.subject,
                Type: x.type,
                "Descriptive Group": x.descriptiveGroupC,
                "General Group": x.generalGroupC,
                "Action Required Or Notification":
                  x.actionRequiredOrNotificationC,
                "Action To Take": x.actionToTakeC?.includes("\n")
                  ? x.actionToTakeC.replaceAll("\n", "")
                  : x.actionToTakeC,
                "Agent Unknown": x.agentUnknownC,
                Amount: x.amountC,
                "Close Reason": x.closeReasonC,
                "Customer #": x.customerC,
                "Employee Status": x.employeeStatusC,
                Exceptions: x.exceptionsC,
                Dispute: x.disputeC,
                "Full Pay": x.fullPayC ? "Yes" : "No",
                Policy: x.policyC,
                Manager: x.rslC,
                "Manager Email": x.rslEmailC,
                "Scorecard Area": x.scorecardAreaC,
                "Scorecard Area Other": x.scorecardAreaOtherC,
                "Suspend To": x.suspendToC
                  ? new Date(x.suspendToC)?.toLocaleDateString()
                  : "",
                Escalated: x.isEscalated,
                "Write Off Amount": x.writeOffAmountC ? x.writeOffAmountC : "",
                "Last Modified By": x.lastModifiedBy,
                "Last Modified Date": x.modifiedDate
                  ? new Date(x.modifiedDate)?.toLocaleDateString()
                  : "",
                "Closed Date": x.closedDate
                  ? new Date(x.closedDate)?.toLocaleDateString()
                  : "",
                "Created By": x.createdBy,
                "Created Date": x.createdDate
                  ? new Date(x.createdDate)?.toLocaleDateString()
                  : "",
                "Is Active": x.isActive ? "True" : "False",
              };
            })
          );
          downloadRef.current.link.click();
          toast.fire(
            "Download Scorceard",
            "Scorecard downloaded successfully.",
            "success"
          );
        }
      },
      onError: (error) => {
        if (error) {
          toast.fire(
            "Download Scorecard",
            "Server Error: Cannot download Scorecard.",
            "error"
          );
        }
      },
    });
  };
  const csvReport = {
    filename: "ScorecardReport" + dateTimeToday + ".csv",
    data: scoreCardExportData,
  };

  if (location.state !== null && location.state !== undefined) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (searchId !== "") {
      try {
        notificationFilterById(searchId, "Scorecard", null).then((result) => {
          setFilteredScorecard(result);
          setSearchId("");
          history.push("/employeetab/scorecard");
        });
      } catch (error) {}
    }
  }, [searchId]);

  useEffect(() => {
    if (recordIdFromRecent) {
      setIsSearching(true);
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          null
        ).then((result) => {
          setFilteredScorecard(result);
          setSearchId("");
          setFilter(true);
          setCaseNumber(recordIdFromRecent.recordId);
          if (recordIdFromRecent.subModuleName === "EmpEdit") {
            handleEdit(result[0]);
            setIsEditState(true);
          }
          history.replace("");
        });
      } catch (error) {}
    } else {
      setFilteredScorecard([]);
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [recordIdFromRecent]);
  const searchClicked = () => {
    tableRef.current && tableRef.current.onQueryChange();
  };

  useEffect(() => {
    if (isSort) {
      setSearchInputsData({ ...searchInputsData, Sort: orderBy });
      searchClicked();
      SetIsSort(false);
    }
  }, [isSort, orderBy]);

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Scorecard were deactivated successfully",
        "success"
      );
      queryClient.invalidateQueries("GetScoreCard");
      queryClient.invalidateQueries("GetScoreCardsList");
      searchClicked();
      //ssearchRefetch();
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Scorecards were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Bulk deactivation of Scorecards failed",
          "Server Error: Cannot deactivate Scorecards",
          "error"
        );
      }
      queryClient.invalidateQueries("GetScoreCard");
      queryClient.invalidateQueries("GetScoreCardsList");
    } else {
      toast.fire(
        "Bulk deactivation of Scorecards failed",
        "Server Error: Cannot deactivate Scorecards",
        "error"
      );
      queryClient.invalidateQueries("GetScoreCard");
      queryClient.invalidateQueries("GetScoreCardsList");
    }
    resetDeacData();
  }

  const handleEdit = (rowDetails) => {
    var empOffCode = empData?.filter((x) => x.id === rowDetails?.contactId);
    setRowToEdit({
      ...rowDetails,
      empOfficeCode: empOffCode[0]?.officeCode,
      contactOwner: rowDetails.createdBy,
      suspendToC:
        rowDetails.suspendToC === null
          ? null
          : rowDetails.suspendToC.slice(0, 10),
      fullPayC:
        rowDetails.fullPayC === null ? "" : rowDetails.fullPayC ? "Yes" : "No",
      baseUrl: window.location.origin,
      createdDate:
        rowDetails.createdDate === null
          ? null
          : rowDetails.createdDate.slice(0, 10),
      closedDate:
        rowDetails.closedDate === null
          ? null
          : rowDetails.closedDate.slice(0, 10),
    });
    setIsEditState(!isEdit);
  };

  const onClickScorecard = (rowData) => {
    setShowState(true);
    setRowViewData(rowData);
  };
  const onClickCancelShow = () => {
    setShowState(false);
    setRowViewData([]);
    setOnClose(true);
  };

  const oldValues = {
    Account: "",
    CaseNumber: "",
    Contact: "",
    CreatedBy: "",
    CreatedDate: "",
    Status: "",
    ActionRequiredOrNotificationC: "",
  };

  const [oldFilteredValue] = useState(oldValues);

  useEffect(() => {
    setSelectedRowsToDelete([]);
  }, [setSelectedRowsToDelete]);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRowsToDelete(forDelete);
  };
  const handleBulkDelete = () => {
    const ids = selectedRowsToDelete?.map((row) => row.caseNumber);
    BulkDeleteVendor(ids);
    setOpenModalDelete(false);
    setSelectedRowsToDelete([]);
  };
  const scoreCardDataList = async (query) => {
    try {
      if (isOnClose) {
        setOnClose(false);
        query.page = stayData.CurrentPage - 1;
        query.pageSize = stayData.PageSize;
      }
      const resp = await getScoreCardList(query, searchInputsData);
      // Check if resp is undefined
      if (resp === undefined || resp?.data === null) {
        setIsScorecardLoading(false);
        return {
          data: [],
          page: 0,
          pageSize: 0,
          totalCount: 0,
        };
      }

      // Parse headers only if they exist
      const headers = resp?.headers
        ? JSON.parse(JSON.stringify(resp.headers))
        : {};
      // Parse x-pagination header only if it exists
      const pageHeaders = headers["x-pagination"]
        ? JSON.parse(headers["x-pagination"])
        : {};
      setIsScorecardLoading(false);
      setStayData(pageHeaders);
      return {
        ...query,
        data: resp?.data,
        page: pageHeaders.CurrentPage - 1,
        pageSize: pageHeaders.PageSize,
        totalCount: pageHeaders.TotalCount,
      };
    } catch (error) {
      setIsScorecardLoading(false);
      // Handle any errors that might occur during the async operation
      return {
        ...query,
        data: [],
        page: 0,
        pageSize: 0,
        totalCount: 0,
      };
    }
  };

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  const matColumns = [
    {
      title: "Scorecard Number",
      field: "caseNumber",
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              onClickScorecard(rowdata);
              setIsScorecardLoading(true);
            }}
          >
            <span className="blueAndBold underline">
              {String(rowdata.caseNumber)?.padStart(10, "0")}
            </span>
            <br></br>
          </div>
        );
      },
    },
    {
      title: "Office Name",
      field: "account",
    },
    {
      title: "Contact Name",
      field: "contact",
    },
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Subject",
      field: "subject",
    },
    {
      title: "Type",
      field: "type",
    },
    {
      title: "Scorecard Area",
      field: "scorecardAreaC",
    },
    {
      title: "Action Required OR Notification Only",
      field: "actionRequiredOrNotificationC",
      render: (rowDetails) => {
        return (
          <div>
            <span className="">{rowDetails.actionRequiredOrNotificationC}</span>
            <br></br>
          </div>
        );
      },
    },
    {
      title: "Date Opened",
      field: "createdDate",
      render: (rowDetails) => {
        return (
          <div>
            <span className="">
              {rowDetails.createdDate
                ? new Date(rowDetails.createdDate)?.toLocaleDateString()
                : ""}
            </span>
            <br></br>
          </div>
        );
      },
    },
    {
      title: "Owner Name",
      field: "createdBy",
    },
    {
      title: "IsActive",
      field: "isActive",
      render: (rowDetails) => {
        return (
          <div>
            <span className="">{rowDetails.isActive ? "True" : "False"}</span>
            <br></br>
          </div>
        );
      },
    },
    {
      title: "Action",
      name: "Action/s",
      align: alignCenter,
      render: (rowData) => {
        return userPermissions.includes(editPermission) ? (
          <div className="flex place-content-center mr-4">
            <ButtonForModal
              className={"border border-quaternary text-white bg-quaternary"}
              onClick={() => {
                handleEdit(rowData);
                setRowEditData(rowData);
                setEditState(true);
                setIsScorecardLoading(true);
              }}
              isDisabled={false}
            >
              <PencilSquareIcon className="h-4 w-4" />
              Edit
            </ButtonForModal>
          </div>
        ) : (
          ""
        );
      },
    },
  ];
  const handleSortChange = (orderBy, orderDirection) => {
    const orderField = matColumns[orderBy]?.field;
    if (orderField !== undefined) {
      setorderBy(orderField + " " + orderDirection);
    } else {
      setorderBy("");
    }
    SetIsSort(true);
  };
  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${
      selectedRowsToDelete
        ? selectedRowsToDelete?.length > 1
          ? "Scorecards"
          : "Scorecard"
        : ""
    }?`}</div>
  );

  return (
    <>
      <div className="px-8 py-4 min-h-fitmin-h-fit">
        {isAdd || isEdit ? (
          <ScoreCardForm
            isAdd={isAdd}
            isEdit={isEdit}
            setIsAdd={setIsAddState}
            setIsEdit={setIsEditState}
            setOnClose={setOnClose}
            searchClicked={searchClicked}
          />
        ) : isShow ? (
          <div className="relative px-4 py-4 box-shadow border-quinary border-l-2">
            <ScoreCardRowDetails
              rowData={rowViewData}
              rowIsExpanded={true}
              handleEdit={handleEdit}
              onClickCancelShow={onClickCancelShow}
              setIsAdd={setIsAddState}
              setReset={false}
            />
          </div>
        ) : (
          <div className="">
            <div>
              <div className="flex gap-2 items-center">
                <div>
                  <TicketIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    Scorecard Module
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    All Scorecards
                  </h1>
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-between pt-2">
              {isAdd || isEdit || isShow ? (
                ""
              ) : (
                <div className="space-x-4 items-center">
                  <button
                    className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                    gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                    onClick={() => {
                      setFilter(!filter);
                    }}
                  >
                    <div>Filter By</div>
                    <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                  </button>
                </div>
              )}
              <div className="gap-2 flex items-center">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="Add"
                    onClick={() => {
                      setIsAddState(!isAdd);
                      setAddState(true);
                      setIsScorecardLoading(true);
                    }}
                  />
                ) : (
                  ""
                )}
                <div>
                  <DownloadButton
                    buttonValue={
                      scoreCardDownloadLoading
                        ? "Downloading..."
                        : "Download File"
                    }
                    onClick={() => {
                      exportData();
                    }}
                    disabled={scoreCardDownloadLoading}
                  />
                  <CSVLink ref={downloadRef} {...csvReport}></CSVLink>
                </div>
              </div>
            </div>
            {userPermissions.includes(editPermission) ? (
              <div className="text-secondary italic text-xs3 py-2">
                {!isEdit ? (
                  <div>
                    <p className="self-center font-bold italic inline-block mr-1">
                      Note:{" "}
                    </p>
                    Tick the box to deactivate some data.
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              ""
            )}
            <main className="flex justify-between">
              {isAdd || isEdit || isShow
                ? ""
                : filter && (
                    <div className="w-1/4 bg-white pb-4">
                      <div className="mb-4">
                        {
                          <TableFilters
                            scoreCardDataList={scoreCardDataList}
                            oldFilteredValue={oldFilteredValue}
                            setCaseNumberValue={caseNumber}
                            setFilteredScorecard={setFilteredScorecard}
                            isSearching={isSearching}
                            setIsSearching={setIsSearching}
                            clearFilter={clearFilter}
                            setClearFilter={setClearFilter}
                            setReset={setReset}
                            setIds={setIds}
                            scoreCardLists={scoreCardLists}
                            searchClicked={searchClicked}
                            employeeList={empData}
                            empLoading={empLoading}
                            setIsScorecardLoading={setIsScorecardLoading}
                          />
                        }
                      </div>
                    </div>
                  )}
              <div
                className={
                  !filter || isShow
                    ? "mb-4 w-full bg-white overflow-x-auto box-shadow"
                    : "w-full h-5/6 bg-white overflow-x-auto box-shadow "
                }
              >
                <div className="grid grid-row">
                  <MaterialTableTS
                    data={scoreCardDataList}
                    isLoading={isScorecardLoading}
                    tableRef={tableRef}
                    pageSize={
                      tableRef?.current?.dataManager.pageSize !== undefined
                        ? tableRef?.current?.dataManager.pageSize
                        : stayData?.PageSize
                        ? stayData?.PageSize
                        : 10
                    }
                    onSearchChange={undefined}
                    columns={matColumns}
                    title="Scorecard"
                    selection={userPermissions.includes(deletePermission)}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRowsToDelete}
                    setConfirmModalOpen={setOpenModalDelete}
                    onOrderChange={(orderBy, orderDirection) => {
                      handleSortChange(orderBy, orderDirection);
                    }}
                  />
                </div>
              </div>
            </main>
          </div>
        )}
      </div>
      <ConfirmBoxDelete
        ModalTitle="Deactivate Scorecard"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </>
  );
};
